import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Button } from "@material-ui/core";

const useStyles = makeStyles({
  jbutton: {
    background:
      "linear-gradient(45deg, rgb(33, 150, 243) 30%, rgb(33, 203, 243) 90%);",
    borderRadius: 3,
    border: 0,
    fontSize: 16,
    boxShadow: "rgba(33, 203, 243, 0.3) 0px 3px 5px 2px",
    color: "white",
    height: 48,
    padding: "0 30px"
  }
});

export default function JButton(props) {
  const classes = useStyles();

  return (
    <Button
      className={classes.jbutton}
      component={props.component}
      to={props.to}
    >
      {props.children}
    </Button>
  );
}
